export default {
  login: 'Login',
  index: 'Index',
  ticketManage: 'TicketManage',
  workbench: 'WorkBench',
  planManage: 'PlanManage',
  messageAccount: 'MessageAccount',
  templateManage: 'TemplateManage',
  ruleManage: 'RuleManage',
  analyseAll: 'AnalyseAll',
  analyseAging: 'AnalyseAging',
  analyseEfficiency: 'AnalyseEfficiency',
  analyseBasic: 'AanalyseBasic',
  map: 'Map Positioning',
  siteOverview: 'Site List',
  deviceOverview: 'Device Overview',
  historicalData: 'Historical Data',
  curveAnalysis: 'Curve Analysis',
  statisticalAnalysis: 'Statistical Analysis',
  faultStatistics: 'Fault Statistics',
  operationStatistics: 'Operation Statistics',
  comparativeAnalysis: 'Comparative Analysis',
  faultManagement: 'Fault Management',
  system: 'System Configuration',
  userManage: 'Account Management',
}
